import { Box, Link, Stack, Button, Typography, Grid } from "fashion/fabrics";
import { LaunchIcon, FindInPageIcon, TravelExploreIcon } from "fashion/icons";

const LINK_CARD_MEMOIR = "https://memoir.cards";
const LINK_PDF_CARD_FORMAT =
  "https://drive.google.com/file/d/1w2MkrG036tKRAzIhsnMgDmFC3deWi5aa/view";

const CodexLauncher = () => (
  <Grid container rowSpacing={1} columnSpacing={1}>
    <Grid size={{ xs: 12, sm: 6 }}>
      <Stack gap={3} height="100%" justifyContent="center">
        <Typography variant="h3" textAlign="center">
          Create simple direct interfaces with{" "}
          <Box color="secondary.main" component="span" display="inline">
            Cards
          </Box>
        </Typography>
        <Typography color="text.secondary">
          Eliminates the complexity of creating{" "}
          <Box color="secondary.main" component="span" display="inline">
            navigable interfaces
          </Box>{" "}
          by creating cards chained with up to 24 links each.
        </Typography>
        <Box>
          <Button
            component={Link}
            href={LINK_CARD_MEMOIR}
            variant="outlined"
            size="large"
            color="secondary"
            startIcon={<TravelExploreIcon />}
            endIcon={<LaunchIcon />}
          >
            Card Memoir
          </Button>
          <Typography mt={0.5} color="text.disabled" variant="body2">
            Launches the web application
          </Typography>
        </Box>
        <Link
          href={LINK_PDF_CARD_FORMAT}
          variant="body2"
          color="text.disabled"
          display="inline-flex"
          target="_blank"
          title="Card Format Introduction PDF"
        >
          <FindInPageIcon sx={{ mr: 0.5 }} fontSize="small" />
          Read more about the card format
        </Link>
      </Stack>
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <img
        width="100%"
        height="100%"
        style={{ objectFit: "cover", borderRadius: 32 }}
        src={process.env.PUBLIC_URL + "/codex/Card_Format.png"}
        alt="Card Format"
      />
    </Grid>
  </Grid>
);

export default CodexLauncher;
